import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
// Side-effect import only: constructing the singleton is what starts the
// connection. Keeps the socket in the eager bundle even if routes go lazy.
import '../services/websocket';
const WebSocketContext = createContext(undefined);
export const useWebSocket = () => {
    const context = useContext(WebSocketContext);
    if (context === undefined) {
        throw new Error('useWebSocket must be used within a WebSocketProvider');
    }
    return context;
};
// No connect() here on purpose: the webSocketService singleton connects itself
// at import time (its constructor runs activity detection, which checks
// connection state), reconnects on activity/visibility changes, and connects
// lazily from subscribe(). Calling connect() from an effect here only raced with
// the import-time attempt and hit the service's "already connecting" guard.
export const WebSocketProvider = ({ children }) => {
    return _jsx(WebSocketContext.Provider, { value: {}, children: children });
};
